import React, { useEffect, useState } from 'react';

const Preloader = () => {
   const [loading, setLoading] = useState(true);
   const [hidden, setHidden] = useState(false);

   useEffect(() => {
      const finishLoading = () => {
         setLoading(false);
         setTimeout(() => setHidden(true), 500);
      };

      if (document.readyState === 'complete') {
         finishLoading();
      } else {
         window.addEventListener('load', finishLoading);
         return () => window.removeEventListener('load', finishLoading);
      }
   }, []);

   if (hidden) return null;

   return (
      <div className={`preloader${loading ? '' : ' preloader--hidden'}`}>
         <div className="preloader__inner">
            <img
               src="assets/img/logo/harsoft_logo_icon_svg.svg"
               alt="Harsoft Solutions"
               className="preloader__logo"
            />
            <span className="preloader__spinner"></span>
         </div>
      </div>
   );
};

export default Preloader;
